var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-icon',{staticClass:"add-btn",attrs:{"name":"add","color":"#1989fa","size":"40px"},on:{"click":_vm.handleAdd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }